import getCustomHiddenFields from "../customHiddenFields";
import getHiddenFields from "../hiddenFields";
import disableStylesheets from "./disableStylesheets";
import formHandlers, { handleDefaultStateAndLabelFormRows } from "./formHandlers";
import handleDemoLicenseRegistration, { removeDlrCookie } from "./demoLicenseRegistration";
import handleMultistepForm from "./mutlistep";
import { isEmailValid } from "./validation";

export default function() {
    let initialized = false;

    removeDlrCookie();

    if (typeof MktoForms2 === "undefined") return;

    MktoForms2.whenRendered(function(form) {
        const formElement = form.getFormElem()[0];

        handleDefaultStateAndLabelFormRows(formElement);

        if (!initialized) {
            disableStylesheets(formElement);
            formHandlers(formElement);
            handleDemoLicenseRegistration(formElement);
            handleMultistepForm(form, formElement);

            form.onValidate(() => {
                isEmailValid(form);
            });

            form.onSubmit(() => {
                const customHiddenFields = getCustomHiddenFields();
                const hiddenFields = getHiddenFields();

                form.vals(customHiddenFields);
                form.vals(hiddenFields);
            });

            initialized = true;
        }
    });
}
